// @flow

import * as React from 'react';

export type Icon = React.Component<React$ElementProps<'svg'>>;
